import CustomRedoBtn from 'components/tool/Editor/ButtonDiv/RedoButton';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { redoRoofToolLines } from 'store/slices/RoofToolLinesSlice';
import { redoEditFacetState } from 'store/slices/ToolSlice';

export default function RedoButton() {
	const dispatch = useDispatch();
	const { activeRoofTool, currentIndex: roofLinesIndex, linesHistory } = useSelector((state: RootState) => state.roofToolLines.data);
	const shouldDisable = (!activeRoofTool) || roofLinesIndex >= linesHistory.length - 1;
	const handleClick = () => {
		if(activeRoofTool) {
			dispatch(redoRoofToolLines());
		} else {
			dispatch(redoEditFacetState());
		}
	};

	return (
		<CustomRedoBtn
			id="edge-redo"
			className="active edge-redo"
			disabled={shouldDisable}
			onClick={handleClick}
		/>
	);
}
